// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4c9be92b","453":"abbd93df","455":"04e99bc0","977":"43d902e5"}[chunkId] + ".chunk.js";
};